import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Markdown from '../Markdown'
import { colours } from '../player/playerStyles'

const TONES = {
  good: { Icon: CheckCircleIcon, colour: colours.good, soft: colours.goodSoft },
  bad: { Icon: CancelIcon, colour: colours.bad, soft: colours.badSoft },
  info: { Icon: InfoOutlinedIcon, colour: colours.accent, soft: colours.accentSoft },
}

// Feedback on an answer. The outcome is always given in words and with an
// icon, never by colour alone.
const Feedback = ({ tone = 'info', label, children, sx }) => {
  const { Icon, colour, soft } = TONES[tone] ?? TONES.info
  return (
    <Box sx={{ display: 'flex', gap: 1.25, p: 1.5, borderRadius: 1, bgcolor: soft, borderLeft: `4px solid ${colour}`, ...sx }}>
      <Icon sx={{ color: colour, mt: '2px', flexShrink: 0 }} aria-hidden="true" />
      <Box sx={{ minWidth: 0 }}>
        {label && (
          <Typography sx={{ fontSize: '1.0625rem', fontWeight: 700, color: colour, lineHeight: 1.5 }}>{label}</Typography>
        )}
        {children && <Markdown>{children}</Markdown>}
      </Box>
    </Box>
  )
}

export default Feedback
